"use strict";
var hlp = require('common/helpers');
var Menu = require('../helpers/menu');
var bildnrsCtrl = require('./bildnrsCtrl');
var MENUENTRIES = require('../helpers/menuentries');
var fieldEntryBildnrCtrl = function($scope, $uibModal, $sce, $http) {
  var init = function() {
    initMenu();
  };
  var initMenu = function() {
    var menu = new Menu();
    var group = menu.createGroup();
    group.addItem(MENUENTRIES.search, function() {
      $scope.showBildnrs();
    }, true);
    if ($scope.schema.comments) {
      var group = menu.createGroup();
      group.addItem(MENUENTRIES.comments, $scope.showComments, true);
    }
    if (hlp.isSet($scope.schema.flags)) {
      group = menu.createGroup();
      if ($scope.schema.flags.primary) {
        group.addItem(MENUENTRIES.primary, function() {
          $scope.toggleFlagWrapper($scope.entry, 'primary');
        }, true);
      }
      if ($scope.schema.flags.outdated) {
        group.addItem(MENUENTRIES.outdated, function() {
          $scope.toggleFlagWrapper($scope.entry, 'outdated');
        }, true);
      }
      if ($scope.schema.flags.hidden) {
        group.addItem(MENUENTRIES.hidden, function() {
          $scope.toggleFlagWrapper($scope.entry, 'hidden');
        }, true);
      }
      group = menu.createGroup();
      if ($scope.schema.flags.detail) {
        group.addItem(MENUENTRIES.detail, function() {
          $scope.toggleFlagWrapper($scope.entry, 'detail');
        }, true);
      }
      if ($scope.schema.flags.total) {
        group.addItem(MENUENTRIES.total, function() {
          $scope.toggleFlagWrapper($scope.entry, 'total');
        }, true);
      }
    }
    if ($scope.schema.multiple) {
      group = menu.createGroup();
      group.addItem(MENUENTRIES.add, function() {
        $scope.addEntry();
      }, true);
      group.addItem(MENUENTRIES.remove, function() {
        $scope.removeEntry($scope.entry);
      }, true);
    }
    menu.calcShow();
    $scope.menu = menu;
  };
  $scope.showBildnrs = function() {
    var modal = $uibModal.open({
      templateUrl: 'documenteditor/templates/bildnrs.ng.html',
      backdrop: 'static',
      controller: bildnrsCtrl,
      size: 'lg',
      resolve: {bildnrsParams: function() {
          if (!hlp.isSet($scope.entry.value)) {
            $scope.entry.value = [];
          }
          return {bildnr: $scope.entry.value};
        }}
    });
    modal.result.then(function(picture) {
      $scope.entry.value = picture.id;
    });
  };
  $scope.toggleFlagWrapper = function(entry, flag, value) {
    $scope.toggleFlag(entry, flag, value);
    if (entry.flags[flag] == true) {
      switch (flag) {
        case 'detail':
          $scope.toggleFlag($scope.entry, 'total', false);
          break;
        case 'total':
          $scope.toggleFlag($scope.entry, 'detail', false);
          break;
        case 'hidden':
          $scope.toggleFlag($scope.entry, 'primary', false);
          break;
        case 'primary':
          for (var i = 0; i < $scope.entries.length; i++) {
            $scope.toggleFlag($scope.entries[i], 'primary', false);
          }
          $scope.toggleFlag($scope.entry, 'primary', true);
          $scope.toggleFlag($scope.entry, 'hidden', false);
          break;
      }
    }
  };
  init();
};
fieldEntryBildnrCtrl.$inject = ['$scope', '$uibModal', '$sce', '$http'];
module.exports = fieldEntryBildnrCtrl;
